var OperationLogModule = (function () {
    function OperationLogModule() {
    }
    return OperationLogModule;
}());
export { OperationLogModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/operation-log/operation-log.module.ts.pre-build-optimizer.js